import { Button } from "@chakra-ui/react";
import { React } from "react";

const ButtonText = ({ children, onclick, variant, size, active, ...props }) => {
    return (
        <Button
            variant={variant}
            size={size ? size : "lg"}
            rounded="full"
            borderWidth="1px"
            fontWeight="300"
            onClick={onclick}
            _hover={{ bg: "gray.100" }}
            color="black"
            boxShadow="md"
            fontSize={{ md: "md", base: "xs" }}
            _focus={{
                boxShadow: "outline",
            }}
            px={{ md: 5, base: 2 }}
            py={3}
            aria-label="opción"
            bg={active ? "brand.500" : "white"}
        >
            {children}
        </Button>
    );
};

export default ButtonText;
